/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  call,
  put,
  takeLatest,
  takeEvery,
  ForkEffect,
} from "redux-saga/effects";
import {
  getApplicationTokens,
  getApplicationTokensSuccess,
  getApplicationTokensFailure,
  getApplicationStats,
  getApplicationStatsSuccess,
  getApplicationStatsFailure,
} from "./slice";
import getServiceTokensApi, { ServiceTokenType } from "#/apis/infra/getServiceTokens";
import getStatisticsApi from "#/apis/infra/getStatistics";
import InternalResponse from "#/types/internalResponse";
import { ApplicationStatistics } from "./types";

function* handleGetApplicationTokens(
  action: ReturnType<typeof getApplicationTokens>,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Generator<any, void, any> {
  try {
    const { accessToken } = action.payload;

    console.log("[Applications Saga] Fetching tokens...");

    const response: InternalResponse<ServiceTokenType> = yield call(getServiceTokensApi, {
      token: accessToken,
    });

    console.log("[Applications Saga] Tokens response:", response);

    // eslint-disable-next-line no-nested-ternary
    const tokens = response.success && response.data
      ? Array.isArray(response.data) ? response.data : [response.data]
      : [];

    yield put(getApplicationTokensSuccess(tokens));
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("[Applications Saga] Error:", error);
    yield put(getApplicationTokensFailure(error.message || "Failed to fetch tokens"));
  }
}

function* handleGetApplicationStats(
  action: ReturnType<typeof getApplicationStats>,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Generator<any, void, any> {
  try {
    const {
      accessToken,
      serviceTokenId,
      startAt,
      endAt,
    } = action.payload;

    const response: InternalResponse<ApplicationStatistics> = yield call(
      getStatisticsApi,
      {
        params: {
          start_at: startAt,
          end_at: endAt,
          unsafe_count: 1000,
          error_count: 1000,
          service_token_id: serviceTokenId,
        },
        token: accessToken,
      },
    );

    if (response.success && response.data) {
      yield put(
        getApplicationStatsSuccess({
          serviceTokenId,
          data: response.data as ApplicationStatistics,
        }),
      );
    } else {
      yield put(
        getApplicationStatsFailure({
          serviceTokenId,
          error: response.msg || "Failed to fetch statistics",
        }),
      );
    }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    yield put(
      getApplicationStatsFailure({
        serviceTokenId: action.payload.serviceTokenId,
        error: error.message || "Failed to fetch statistics",
      }),
    );
  }
}

export default function* applicationsSaga(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(getApplicationTokens.type, handleGetApplicationTokens);
  yield takeEvery(getApplicationStats.type, handleGetApplicationStats);
}
